import { AutoMap } from "@automapper/classes";
import { EAPRType } from "./enums/APR-type";
import { EExpositionClimatique } from "./enums/exposition-climatique";
import { EMeteoType } from "./enums/meteo-type";

export class ProcessSamplingCondition {

    @AutoMap()
    Apr!: EAPRType;
    @AutoMap()
    Temoin!: string;
    @AutoMap()
    Hygrometrie1?: number ;
    @AutoMap()
    Hygrometrie2?: number ;
    @AutoMap()
    Hygrometrie3?: number ;
    @AutoMap()
    VitesseVent1?: number ;
    @AutoMap()
    VitesseVent2?: number ;
    @AutoMap()
    VitesseVent3?: number ;
    @AutoMap()
    Meteo?: EMeteoType;
    @AutoMap()
    ExpositionClimatique!: EExpositionClimatique;
    
    public constructor(init?: Partial<ProcessSamplingCondition>) {
        Object.assign(this, init);
    }
}